import axios from 'axios';
import baseURL from '../../Config';
export async function crmRequest(path, method = 'get', data) {
    const session = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
    const token = session?.data?.token || session?.data?.accessToken;
    if (!token) throw new Error('Tu sesión ha vencido. Vuelve a iniciar sesión.');
    try {
        const response = await axios({ url: `${baseURL}sales/crm${path}`, method, data, timeout: 15000, headers: { authorization: `Bearer ${token}` } });
        return response.data.data;
    } catch (error) {
        throw Object.assign(new Error(error.response?.data?.message || 'No pudimos conectar. Intenta nuevamente.'), { status: error.response?.status });
    }
}

export async function downloadQuotationFile(opportunityId, file) {
    const session = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
    const token = session?.data?.token || session?.data?.accessToken;
    if (!token) throw new Error('Tu sesión ha vencido.');
    const response = await axios({ url: `${baseURL}sales/crm/opportunities/${opportunityId}/quotation/files/${file.id}`, responseType: 'blob', timeout: 30000, headers: { authorization: `Bearer ${token}` } });
    const url = URL.createObjectURL(response.data), link = document.createElement('a');
    link.href = url; link.download = file.name; document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
